import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=0787650f&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=0787650f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0787650f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0787650f')) {
      api.createRecord('0787650f', component.options)
    } else {
      api.reload('0787650f', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=0787650f&scoped=true&", function () {
      api.rerender('0787650f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2MaUjJODNQiOc/JS/comp/Voucher.vue"
export default component.exports